<template>
  <div>
    <div class="card">
      <div class="card-body">
        <b-row>
          <router-link :to="{name: 'schoolsCreate'}"  style="position: absolute;right:5em;z-index:10;">
            <a-button type="primary" shape="circle" icon="plus" class="ml-3"/>
          </router-link>
          <div class="col">
            <h5 class="mb-4">
              <strong>Lista de instituciones</strong>
              <a-button class="ml-2" type="primary" v-b-toggle.collapse-1  shape="circle" icon="search"/>
            </h5>
          </div>
        </b-row>
        <b-collapse id="collapse-1" class="mt-2">
          <b-form>
            <b-row>
              <div class="col-sm-10 col-md-4 col-lg-3 col-xl-2">
                <b-form-group id="input-group-1" label="Código:" label-for="input-1">
                  <b-form-input id="input-1" type="number" v-model="form.id" placeholder="Ingrese el código"></b-form-input>
                </b-form-group>
              </div>
              <div class="col-sm-10 col-md-4 col-lg-3 col-xl-2">
                <b-form-group id="input-group-2" label="Nombre:" label-for="input-2">
                  <b-form-input id="input-2" v-model="form.name" placeholder="Ingrese el nombre"></b-form-input>
                </b-form-group>
              </div>
            </b-row>
          </b-form>
        </b-collapse>
        <b-row>
          <div class="col">
            <b-table id="my-table" v-if="(schools.rows).length !== 0" striped hover :fields="columns" :items="schools.rows" head-variant="light" responsive>
              <template #cell(logo)="school">
                <strong>{{ school.item.logo && school.item.idAvatar != '6055187dd1a80304c7500872' ? 'Si' : 'No'}}</strong>
              </template>
              <template #cell(actions)="school">
                <div>
                  <a-tooltip placement="top">
                    <template slot="title">
                      <span>Ver información</span>
                    </template>
                    <button type="button" @click="() => openModal(school.item.id)" class="btn btn-light mr-2">
                      <i class="fa fa-eye" />
                    </button>
                  </a-tooltip>
                  <a-tooltip placement="top">
                    <template slot="title">
                      <span>Editar</span>
                    </template>
                    <router-link :to="{ name: 'schoolsEdit', params: { idSchool: school.item.id } }" class="btn btn-light mr-2" v-if="hasRole([ consts.rolesText.SU ])">
                      <i class="fa fa-pencil text-blue" />
                    </router-link>
                  </a-tooltip>
                  <a-tooltip placement="top">
                    <template slot="title">
                      <span>Ver/Agregar admins</span>
                    </template>
                    <button type="button" v-on:click="openModalAdmin(school.item.id)" class="btn btn-light mr-2">
                      <i class="fa fa-male text-warning" />
                    </button>
                  </a-tooltip>
                  <a-tooltip placement="top">
                    <template slot="title">
                      <span>Inyectar usuario de pruebas</span>
                    </template>
                    <button type="button" v-on:click="openModalDebug(school.item.id)" class="btn btn-light mr-2">
                      <i class="fa fa-bug text-warning" />
                    </button>
                  </a-tooltip>
                  <a-tooltip placement="top">
                    <template slot="title">
                      <span>Eliminar institución</span>
                    </template>
                    <button type="button" v-on:click="deleteSchool(school.item)" class="btn btn-light mr-2">
                      <i class="fa fa-times-circle text-red" />
                    </button>
                  </a-tooltip>
                </div>
              </template>
            </b-table>
            <empty-table v-else/>
          </div>
        </b-row>
        <b-row>
          <b-col>
            <b-pagination
              v-model="pagination.currentPage"
              :total-rows="pagination.rows"
              :per-page="pagination.perPage"
              @input="search()"
              aria-controls="my-table"
            ></b-pagination>
          </b-col>
          <b-col class="text-right">
            {{ pagination.rows }} resultados
          </b-col>
        </b-row>
      </div>
    </div>
    <b-modal id="school-details" no-enforce-focus scrollable ref="modal" title="Información de la institución" hide-footer size="lg" @hidden="onHidden">
      <b-row class="justify-content-center mb-2">
        <b-col v-if="schoolSelected.logo">
          <img :src="schoolSelected.logo+'?tr=w-300'"
          @error="event => event.target.src = 'https://ik.imagekit.io/czqsnlwbh2e/users/avatars/user-placeholder_LxKtaNY341.webp'"
          width="200" alt="..." class="img-thumbnail img-fluid" style="display: block; margin-left: auto; margin-right: auto;"><br/>
        </b-col>
        <b-col v-else>
          <img src="https://ik.imagekit.io/czqsnlwbh2e/users/avatars/user-placeholder_LxKtaNY341.webp"  width="200" alt="..." class="img-thumbnail img-fluid" style="display: block; margin-left: auto; margin-right: auto;"><br/>
        </b-col>
        <b-col sm="12" md="6" class="m-auto">
          <b-row class="m-auto">
            <b class="mr-1">Nombre:</b> {{ this.schoolSelected.name }}
          </b-row>
          <b-row class="m-auto">
            <b class="mr-1">Dirección: </b> {{ this.schoolSelected.address }}
          </b-row>
          <b-row class="m-auto">
            <b class="mr-1">Telefono: </b> {{ this.schoolSelected.phone }}
          </b-row>
          <b-row class="m-auto">
            <b class="mr-1">Correo: </b> {{ this.schoolSelected.email }}
          </b-row>
          <b-row class="m-auto">
            <b class="mr-1">Suscrito desde: </b> {{ this.schoolSelected.createdAt }}
          </b-row>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal id="admin-to-assign" no-enforce-focus scrollable ref="modal2" title="Asignar usuario administrador" hide-footer size="lg" @hidden="onHidden">
      <b-card no-body class="mb-auto">
        <b-row>
          <b-col cols="9" sm="10" md="10" lg="11" class="p-auto">
            <b-button block v-b-toggle="'collapsableAddAdmin'" variant="link" class="m-auto text-left">
              Crear administrador
            </b-button>
          </b-col>
          <b-col cols="1" sm="1" md="1" lg="1" class="p-0">
            <b-button block v-b-toggle="'collapsableAddAdmin'" variant="link" class="m-auto text-left">
              <i :class=" collapsableAddAdmin ? 'fa fa-angle-double-up text-right' : 'fa fa-angle-double-down text-right'" />
            </b-button>
          </b-col>
        </b-row>
        <b-collapse
          :id="'collapsableAddAdmin'"
          :accordion="'adminSettings'"
          role="tabpanel"
          v-model="collapsableAddAdmin"
          class="mt-2"
        >
          <b-form>
            <b-row class="m-auto">
              <div class="col-sm-10 col-md-6 col-xl-4">
                <b-form-group id="input-group-1-admin" label="Identificación:" label-for="input-1-admin">
                  <b-form-input id="input-1-admin" type="number" v-model="formAdmin.cc" placeholder="Ingrese el nip"></b-form-input>
                </b-form-group>
              </div>
              <div class="col-sm-10 col-md-6 col-xl-4">
                <b-form-group id="input-group-2-admin" label="Nombre:" label-for="input-2-admin">
                  <b-form-input id="input-2-admin" v-model="formAdmin.name" placeholder="Ingrese el nombre"></b-form-input>
                </b-form-group>
              </div>
              <div class="col-sm-10 col-md-6 col-xl-4">
                <b-form-group id="input-group-3-admin" label="Apellido:" label-for="input-3-admin">
                  <b-form-input id="input-3-admin" v-model="formAdmin.lastName" placeholder="Ingrese el Apellido"></b-form-input>
                </b-form-group>
              </div>
              <div class="col-sm-10 col-md-8 col-xl-5 mb-3">
                <b-button variant="primary" @click="createAdmin(formAdmin)">Guardar</b-button>
              </div>
            </b-row>
          </b-form>
        </b-collapse>
      </b-card>
      <b-card no-body class="mb-auto">
        <b-row>
          <b-col cols="9" sm="10" md="10" lg="11" class="p-auto">
            <b-button block v-b-toggle="'collapsableAddAdminList'" variant="link" class="m-auto text-left">
              Lista de Administradores
            </b-button>
          </b-col>
          <b-col cols="1" sm="1" md="1" lg="1" class="p-0">
            <b-button block v-b-toggle="'collapsableAddAdminList'" variant="link" class="m-auto text-left">
              <i :class=" collapsableAddAdminList ? 'fa fa-angle-double-up text-right' : 'fa fa-angle-double-down text-right'" />
            </b-button>
          </b-col>
        </b-row>
        <b-collapse
          :id="'collapsableAddAdminList'"
          :accordion="'adminSettings'"
          role="tabpanel"
          v-model="collapsableAddAdminList"
          class="mt-2"
        >
          <b-form>
            <b-row class="m-auto">
              <div class="col-sm-10 col-md-4 col-xl-4 ml-sm-1 ml-xl-2">
                <b-form-group id="input-group-1" label="Identificación:" label-for="input-1">
                  <b-form-input id="input-1" type="number" v-model="userNip" placeholder="Ingrese el nip"></b-form-input>
                </b-form-group>
              </div>
              <div class="col-sm-10 col-md-4 col-xl-4 ml-sm-1">
                <b-form-group id="input-group-2" label="Nombre:" label-for="input-2">
                  <b-form-input id="input-2" v-model="userName" placeholder="Ingrese el nombre"></b-form-input>
                </b-form-group>
              </div>
              <div class="col-xl-12 ml-1">
                <b-table id="my-table2" v-if="(users.rows).length !== 0" striped hover :fields="userColumns" :items="users.rows" head-variant="light" responsive>
                  <template #cell(actions)="user">
                    <div>
                      <a-tooltip placement="top">
                        <template slot="title">
                          <span>Restaurar contraseña</span>
                        </template>
                        <button type="button" v-on:click="restorePassword(user.item.id)" class="btn btn-light mr-2">
                          <i class="fa fa-lock text-green" />
                        </button>
                      </a-tooltip>
                    </div>
                  </template>
                </b-table>
                <empty-table v-else/>
              </div>
            </b-row>
            <b-row>
              <b-col>
                <b-pagination
                  v-model="paginationUsers.currentPage"
                  :total-rows="paginationUsers.rows"
                  :per-page="paginationUsers.perPage"
                  @input="userSearch()"
                  aria-controls="my-table2"
                ></b-pagination>
              </b-col>
              <b-col class="text-right">
                {{ paginationUsers.rows }} resultados
              </b-col>
            </b-row>
          </b-form>
        </b-collapse>
      </b-card>
    </b-modal>
    <b-modal id="school-debug-user" no-enforce-focus scrollable ref="modal2" title="Inyectar usuario de pruebas" hide-footer size="md" @hidden="onHidden">
      <b-form>
        <b-row class="justify-content-center mb-2">
          <div class="col-sm-10 col-md-7 col-xl-7 ml-sm-1 ml-xl-2">
            <b-form-group
              id="fieldset-horizontal"
              label-cols-sm="4"
              label-cols-xl="2"
              content-cols-sm="4"
              content-cols-xl="15"
              description="El usuario y contraseña es 2022."
              label="Rol"
              label-for="input-horizontal"
            >
              <b-form-select v-model="rolSelected" :options="roles"></b-form-select>
            </b-form-group>
          </div>
          <div class="col-sm-10 col-md-4 col-xl-4 ml-sm-1">
            <b-button variant="primary" @click="saveDebugger()">Guardar</b-button>
          </div>
        </b-row>
      </b-form>
    </b-modal>
  </div>
</template>
<script>
import apiClient from '@/services/axios'
import { mapState } from 'vuex'
import axios from 'axios'
import { isOnlyDigits, hasRole, consts, showErrorMessage } from '@/services/utilities'
import store from 'store'
import emptyTable from '@/components/custom/cardEmptyList'
import moment from 'moment'
import Swal from 'sweetalert2'

export default {
  name: 'schoolManagementArea',
  components: { emptyTable },
  data() {
    return {
      form: {
        code: '',
        name: '',
      },
      formAdmin: {
        cc: '',
        name: '',
        lastName: '',
      },
      userNip: '',
      userName: '',
      columns: [
        { key: 'id', label: 'Código' },
        { key: 'name', label: 'Nombre' },
        { key: 'phone', label: 'Telefono' },
        { key: 'logo', label: 'Logo' },
        { key: 'actions', label: 'Acciones', thClass: 'text-center', tdClass: 'text-center' },
      ],
      userColumns: [
        { key: 'cc', label: 'Identificación' },
        { key: 'name', label: 'Nombre' },
        { key: 'lastName', label: 'Apellido' },
        { key: 'actions', label: 'Acciones', thClass: 'text-center', tdClass: 'text-center' },
      ],
      schools: {
        count: 0,
        rows: [],
      },
      users: {
        count: 0,
        rows: [],
      },
      pagination: {
        rows: 0,
        perPage: 10,
        currentPage: 1,
      },
      paginationUsers: {
        rows: 0,
        perPage: 10,
        currentPage: 1,
      },
      rolSelected: null,
      roles: [],
      schoolSelected: {
        id: '',
        name: '',
        logo: '',
        address: '',
        email: '',
        phone: '',
        createdAt: '',
      },
      typingTimer: '',
      collapsableAddAdmin: false,
      collapsableAddAdminList: false,
      consts: consts,
    }
  },
  computed: {
    ...mapState(['user']),
  },
  beforeRouteEnter (to, from, next) {
    function getRoles() {
      return apiClient.get('/roles')
    }

    function getSchools() {
      const sentParams = {
        perPage: 10,
        currentPage: 0,
      }
      return apiClient.get('/schools', { params: { sentParams: sentParams } })
    }

    axios.all([getRoles(), getSchools()])
      .then(axios.spread(function (roles, schools) {
        next((vm) => {
          vm.setDataRoles(null, roles.data.results)
          vm.setDataSchools(null, schools.data)
        })
      }))
      .catch(err => {
        next((vm) => {
          vm.setDataRoles(err, [])
          vm.setDataSchools(err, [])
        })
      })
  },
  watch: {
    'form.id': function () {
      this.getByFields()
    },
    'form.name': function () {
      this.getByFields()
    },
    userNip: function () {
      this.userSearch()
    },
    userName: function () {
      this.userSearch()
    },
  },
  methods: {
    userSearch() { // Guarda un grado llamando a la API
      const sentParams = {
        cc: this.userNip,
        name: this.userName,
        perPage: this.paginationUsers.perPage,
        currentPage: this.paginationUsers.currentPage - 1,
      }
      apiClient.get(`/schools/${this.schoolSelected.id}/users`, { params: { sentParams: sentParams } }).then(response => {
        this.users.rows = response.data.rows
        this.paginationUsers.rows = response.data.count
      }).catch(error => {
        console.log(error)
        this.$notification.error({
          message: 'Ooops ocurrió un error',
          description: showErrorMessage(error),
        })
      })
    },
    async onHidden (e) {
      this.userNip = ''
      this.userName = ''
      this.users.rows = []
      this.users.count = 0
    },
    hasRole(roles) {
      return hasRole(roles, this.user.role)
    },
    async openModal(school) {
      this.getSchool(school)
      this.$bvModal.show('school-details')
    },
    async openModalAdmin(school) {
      await this.getSchool(school)
      await this.userSearch()
      this.$bvModal.show('admin-to-assign')
    },
    async openModalDebug(school) {
      await this.getSchool(school)
      await apiClient.get('/roles').then(response => {
        const data = response.data.results
        const roles = []
        data.forEach(i => {
          if (i.id === 2 || i.id === 9) {
            roles.push({ value: i.id, text: i.name })
          }
          if ((i.id >= 3 && i.id <= 8) && this.schoolSelected.academicModule === true) {
            roles.push({ value: i.id, text: i.name })
          }
          if ((i.id >= 10 && i.id <= 13) && this.schoolSelected.cafeteriaModule === true) {
            roles.push({ value: i.id, text: i.name })
          }
          if (i.id === 14 && this.schoolSelected.libraryModule === true) {
            roles.push({ value: i.id, text: i.name })
          }
          this.roles = roles
        })
        this.roles.unshift({ value: null, text: 'Seleccione un rol' })
      }).catch(error => {
        console.log(error)
        this.$notification.error({
          message: 'Ooops ocurrió un error',
          description: showErrorMessage(error),
        })
      })
      this.$bvModal.show('school-debug-user')
    },
    async saveDebugger() {
      await apiClient.patch(`/schools/${this.schoolSelected.id}/debugger`, { sentParams: this.rolSelected }).then(response => {
        Swal.fire('Usuario de pruebas inyectado con éxito', ' ', 'success')
      }).catch(error => {
        console.log(error)
        this.$notification.error({
          message: 'Ooops ocurrió un error',
          description: showErrorMessage(error),
        })
      })
    },
    async deleteSchool(school) {
      // Solo elimina de userSchool(No elimina nada de informacion relacionada, solo el registro de la tabla)
      Swal.fire({
        title: 'Confirmar eliminación',
        text: '¿Desea eliminar ' + school.name + '?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, eliminar',
        cancelButtonText: 'No',
      }).then(async (result) => {
        if (result.isConfirmed) {
          await apiClient.delete(`/schools/${school.id}`).then(response => {
            Swal.fire('Institución eliminada con éxito', ' ', 'success')
            this.search()
          }).catch(error => {
            console.log(error)
            this.$notification.error({
              message: 'Ooops ocurrió un error',
              description: showErrorMessage(error),
            })
          })
        }
      })
    },
    async restorePassword(id) {
      await apiClient.patch(`/schools/${this.schoolSelected.id}/pw/${id}`).then(response => {
        Swal.fire('Clave restaurada', ' ', 'success')
      }).catch(error => {
        console.log(error)
        this.$notification.error({
          message: 'Ooops ocurrió un error',
          description: showErrorMessage(error),
        })
      })
    },
    async createAdmin() {
      if (!this.formAdmin.name) {
        this.$bvToast.toast('El nombre está vacío o no cumple con las características requeridas', {
          title: 'Nombre inválido',
          variant: 'danger',
          autoHideDelay: 5000,
        })
        return
      }
      if (!this.formAdmin.lastName) {
        this.$bvToast.toast('El apellido está vacío o no cumple con las características requeridas', {
          title: 'Apellido inválido',
          variant: 'danger',
          autoHideDelay: 5000,
        })
        return
      }
      if (!this.formAdmin.cc || !isOnlyDigits(this.formAdmin.cc)) {
        this.$bvToast.toast('La identificación está vacía o no cumple con las características requeridas', {
          title: 'Identificación inválida',
          variant: 'danger',
          autoHideDelay: 5000,
        })
        return
      }
      await apiClient.post(`/schools/${this.schoolSelected.id}/admins`, { sentParams: this.formAdmin }).then(response => {
        Swal.fire(`Usuario admin creado para ${this.schoolSelected.name}`, ' ', 'success')
        this.formAdmin.cc = ''
        this.formAdmin.name = ''
        this.formAdmin.lastName = ''
        this.userSearch()
        this.collapsableAddAdmin = false
        this.collapsableAddAdminList = true
      }).catch(error => {
        console.log(error)
        this.$notification.error({
          message: 'Ooops ocurrió un error',
          description: showErrorMessage(error),
        })
      })
    },
    async getSchool(idSchool) {
      await apiClient.get(`/schools/${idSchool}`).then(response => {
        this.schoolSelected = response.data
        this.schoolSelected.createdAt = moment(this.schoolSelected.createdAt).format('YYYY-MM-DD')
      }).catch(error => {
        console.log(error)
        this.$notification.error({
          message: 'Ooops ocurrió un error',
          description: showErrorMessage(error),
        })
      })
    },
    getByFields() {
      clearTimeout(this.typingTimer)
      this.typingTimer = setTimeout(() => { this.search() }, 500)
    },
    setDataSchools (err, data) { // Carga la informacion del beforeRouteEnter
      if (err) {
        this.error = err.toString()
      } else {
        this.schools = data
        this.pagination.rows = this.schools.count
      }
    },
    setDataRoles (err, data) { // Carga la informacion del beforeRouteEnter
      if (err) {
        this.error = err.toString()
      } else {
        const roles = []
        data.forEach(i => roles.push({ value: i.id, text: i.name }))
        roles.unshift({ value: null, text: 'Seleccione un rol' })
        this.roles = roles
      }
    },
    search() { // Guarda un grado llamando a la API
      const sentParams = {
        schoolCode: this.form.id,
        schoolName: this.form.name,
        perPage: this.pagination.perPage,
        currentPage: this.pagination.currentPage - 1,
      }
      apiClient.get('/schools', { params: { sentParams: sentParams } }).then(response => {
        this.schools = response.data
        this.pagination.rows = this.schools.count
      }).catch(error => {
        console.log(error)
        this.$notification.error({
          message: 'Ooops ocurrió un error',
          description: showErrorMessage(error),
        })
      })
    },
  },
  created() {
    this.accessToken = store.get('accessToken')
  },
}
</script>
